const firebase = require("firebase/app")
require("firebase/auth")
require("firebase/database")
require("firebase/firestore")
require("firebase/messaging")
require("firebase/functions")
require("firebase/storage")
const config = require('../../config')
firebase.initializeApp(config.firebase)
const db = firebase.database()
const auth = firebase.auth()
const storage = firebase.storage()
let Plugin = {
  install: function (Vue){
    if (!Vue.prototype.$Config) {
      Object.defineProperties(Vue.prototype, {
        $Config: {
          get: function () {
            return config
          }
        }
      })
    }
    if (!Vue.prototype.$firebase) {
      Object.defineProperties(Vue.prototype, {
        $firebase: {
          get: function () {
            return firebase
          }
        }
      })
    }
    if (!Vue.prototype.$db) {
      Object.defineProperties(Vue.prototype, {
        $db: {
          get: firebase.database
        }
      })
    }
    if (!Vue.prototype.$auth) {
      Object.defineProperties(Vue.prototype, {
        $auth: {
          get: function () {
            return auth
          }
        }
      })
    }
    if (!Vue.prototype.$storage) {
      Object.defineProperties(Vue.prototype, {
        $storage: {
          get: function () {
            return storage
          }
        }
      })
    }
  }
}
export {Plugin as default, db, auth, storage}